import { appComponentAccessId } from "app/layout/Layout";
import { Location } from "react-router-dom";

export const redirectToClientConfirmationDocEditor = (history, location: Location, options?: { defaultSelection: string }) => {
  /** Code: Switch view to client-confirmation-editor */
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('view', 'client-confirmation-editor');
  if (options?.defaultSelection) searchParams.set('default_selection', options?.defaultSelection);
  history(`${location.pathname}?${searchParams.toString()}`);
  /** Scroll to the top of the screen on redirection */
  document.getElementById(appComponentAccessId)?.scrollTo(0, 0);
};
